import { AspectRatio } from "@chakra-ui/react";
import { FillImage } from "components/images";
import { Section, sectionSpacingY } from "components/section";
import React from "react";
import { TextTitle } from "ui/text";
import { desktopOnlyDisplay, mobileOnlyDisplay } from "utils";
import toolsDiagram from "../../../../public/assets/platform/ai-decisioning/diagram.png";
import mobileToolsDiagram from "../../../../public/assets/platform/ai-decisioning/diagram-mobile.png";

const altText =
  "Flowchart showing centralized online and offline data in the data warehouse or cdp continuously flowing into AI decisioning which is driving LTV, and then into customer experiences. Simultaneously, goals, guardrails, and creatives are flowing into AI decisioning, while customer experiences are driving outcomes, which then feed back into the data warehouse or cdp. The continuous loop is powered by AI decisioning.";

export function AidTools() {
  return (
    <Section my={0} pt={sectionSpacingY}>
      <TextTitle
        size="lg"
        align="center"
        maxW="880px"
        title="Bring the power of AI agents to your existing data and marketing tools"
        description="Hightouch connects directly to your data warehouse and integrates with any marketing platform. AI decisioning agents learn from the freshest, most complete picture of your customer and power communications in any tool."
      />
      <AspectRatio
        display={mobileOnlyDisplay()}
        ratio={{ base: 4 / 3, sm: 614 / 320 }}
        borderRadius="small"
        overflow="hidden"
        pos="relative"
        w="100%"
        mt="bigger"
      >
        <FillImage src={mobileToolsDiagram} alt={altText} />
      </AspectRatio>
      <AspectRatio
        display={desktopOnlyDisplay()}
        ratio={1317 / 522}
        borderRadius="bigger"
        overflow="hidden"
        pos="relative"
        w="100%"
        mt="biggest"
      >
        <FillImage src={toolsDiagram} alt={altText} />
      </AspectRatio>
    </Section>
  );
}
